import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteSABannersStart, getAllSABannersStart, updateSABannerStart, uploadSABannerStart } from '../../../store/redux-slices/superAdminSettings'
import useCheckPermission from '../../../utils/checkPermission'
import useDidMountEffect from '../../../utils/useDidMountEffect'

const useBannerManagement = () => {
  const { loading, SABanners, deleteSAbanners } = useSelector(state => state.superAdminSettings)
  const isInitialRender = useDidMountEffect()
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const { clientsFilterData, portalsFilterData } = useSelector(state => state.tenants)
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [type, setType] = useState('')
  const [data, setData] = useState({})
  const [show, setShow] = useState(false)
  const [deleteModalShow, setDeleteModalShow] = useState(false)
  const [selecteddeletebanner, setSelectedDeleteBanner] = useState({ id: "", name: "" })
  const dispatch = useDispatch()
  const { isHidden } = useCheckPermission()
  const totalPages = SABanners?.pagination?.totalPages || 1
  const totalCount = SABanners?.pagination?.total || 0
  const [validation, setValidation] = useState({
    minRequiredWidth: '',
    minRequiredHeight: '',
    maxRequiredWidth: '',
    maxRequiredHeight: ''
  })
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: ""
  })


  console.log({ SABanners, deleteSAbanners }, "SABannersSABanners")
  useEffect(() => {
    if (data?.bannerType) {
      setValidation({
        minRequiredWidth: 200,
        minRequiredHeight: 200,
        maxRequiredWidth: 300,
        maxRequiredHeight: 300
      })
    }
  }, [data])

  useEffect(() => {
    dispatch(getAllSABannersStart({
      limit: 15,
      pageNo: 1,
    }))
  }, [])

  useEffect(() => {

    if (deleteSAbanners?.success) {
      setDeleteModalShow(false)
      setSelectedDeleteBanner({
        id: "",
        name: ""
      })
    }

  }, [deleteSAbanners])

  useEffect(() => {
    setPage(1)
    dispatch(
      getAllSABannersStart({
        limit: limit,
        pageNo: page,
      })
    )
  }, [limit])

  useEffect(() => {
    !isInitialRender && dispatch(
      getAllSABannersStart({
        limit: limit,
        pageNo: page,
      })
    )
  }, [page])

  useEffect(() => {
    setPage(1)
    getAllSABannersStart()
  }, [limit])

  const handleCreateEdit = (type, data) => {
    setType(type)
    setData(data)
    setShow(true)
  }


  const handleDelete = (id, name) => {
    setSelectedDeleteBanner({
      id: id,
      name: name,
    })
    setDeleteModalShow(true)
    // dispatch(deleteSABannersStart({ name : id }))
    // dispatch(
    //   getAllSABannersStart({
    //     limit: limit,
    //     pageNo: page,
    //   })
    // )
  }

  const handleDeleteYes = () => {
    dispatch(deleteSABannersStart({ name: selecteddeletebanner?.id }))

  }
  const createUpdate = (data) => {
    type === 'Create'
      ? dispatch(uploadSABannerStart({
        data: {
          // bannerType: data?.bannerType,
          image: data?.thumbnail,
          name: data?.name,
          url: data?.url
        },
        limit: '',
        pageNo: ''
      }))
      : dispatch(updateSABannerStart({
        data: {
          pageBannerId: data?.pageBannerId,
          image: data?.thumbnail,
          name: data?.name,
          url: data?.url
        },
        limit: '',
        pageNo: ''
      }))
  }

  return {
    loading,
    selectedClient,
    setSelectedClient,
    selectedPortal,
    setSelectedPortal,
    SABanners: SABanners?.result,
    handleCreateEdit,
    type,
    data,
    setShow,
    show,
    createUpdate,
    clientsFilterData,
    portalsFilterData,
    dispatch,
    isHidden,
    validation,
    setValidation,
    handleDelete,
    page,
    limit,
    setPage,
    setLimit,
    totalPages,
    setDeleteModalShow,
    deleteModalShow,
    selecteddeletebanner,
    handleDeleteYes,
    setImageModal,
    imageModal,
    totalCount
  }
}

export default useBannerManagement
